import Notifications from './connectToStore';
export default Notifications;



// WEBPACK FOOTER //
// ./src/components/Notifications/index.js